export const boldFont = { fontWeight: 500 };
export const lightFont = { fontWeight: 300 };
